export const FETCH_CAPACITY_INPUT_NEW_REQUEST = 'FETCH_CAPACITY_INPUT_NEW_REQUEST';
export const FETCH_CAPACITY_INPUT_NEW_SUCCESS = 'FETCH_CAPACITY_INPUT_NEW_SUCCESS';
export const FETCH_CAPACITY_INPUT_NEW_FAILURE = 'FETCH_CAPACITY_INPUT_NEW_FAILURE';

export const FETCH_CAPACITY_FILTERS_NEW_REQUEST = 'FETCH_CAPACITY_FILTERS_NEW_REQUEST';
export const FETCH_CAPACITY_FILTERS_NEW_SUCCESS = 'FETCH_CAPACITY_FILTERS_NEW_SUCCESS';
export const FETCH_CAPACITY_FILTERS_NEW_FAILURE = 'FETCH_CAPACITY_FILTERS_NEW_FAILURE';
 
export const FETCH_DEFAULT_RAD_CAPACITY_NEW_REQUEST = 'FETCH_DEFAULT_CAPACITY_NEW_REQUEST';
export const FETCH_DEFAULT_RAD_CAPACITY_NEW_SUCCESS = 'FETCH_DEFAULT_CAPACITY_NEW_SUCCESS';
export const FETCH_DEFAULT_RAD_CAPACITY_NEW_FAILURE = 'FETCH_DEFAULT_CAPACITY_NEW_FAILURE';
 
export const UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST = 'UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST';
export const UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS = 'UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS';
export const UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE = 'UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE';
 
export const BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST = 'BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_REQUEST';
export const BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS = 'BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_SUCCESS';
export const BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE = 'BULK_UPDATE_RAD_CAPACITY_INPUT_NEW_FAILURE';
 
export const RAD_CAPACITY_IP_UPLOAD_NEW_REQUEST = 'RAD_CAPACITY_IP_UPLOAD_NEW_REQUEST';
export const RAD_CAPACITY_IP_UPLOAD_NEW_SUCCESS = 'RAD_CAPACITY_IP_UPLOAD_NEW_SUCCESS';
export const RAD_CAPACITY_IP_UPLOAD_NEW_FAILURE = 'RAD_CAPACITY_IP_UPLOAD_NEW_FAILURE';